import React from "react";
import {AuthConsumer} from "./AuthProvider";
import {IAuthService} from "./services/auth-service";

export const Logout = (): JSX.Element => (
    <AuthConsumer>
        {({logout}: IAuthService) => {
            logout();
            return <span>loading...</span>;
        }}
    </AuthConsumer>
);
